module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaBAMAAABFrWFOAAAAJFBMVEUre8sre8sre8sre8vt8POkxOQzgM3l6/HM3Ox0p9pLj9Ksyea0w6TJAAAAA3RSTlPmSklSjzZ3AAAAPklEQVQY02NQMIYCJgZmGNOAwRgOqMQ0C4YzVzjDmJYlMKZZiIuLC4Rp7QIEGKIItQgTEOZS7khkzwvAmIwABMw1xs4HWfgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_previous.png
// module id = slQA
// module chunks = 9